import { createContext, useContext } from 'react';
import { ActorRefFrom } from 'xstate';
import { msaasListingsMachine } from './msaasListing.machine';

type MsaasListingsActorRef = ActorRefFrom<typeof msaasListingsMachine>;
export const MsaasListingsRefContext = createContext<MsaasListingsActorRef | null>(null);

export function useMsaasListingsActorRef() {
  const ref = useContext(MsaasListingsRefContext);
  if (!ref) throw new Error('useMsaasListingsActorRef must be used within MsaasListings.Provider');
  return ref;
}
